var _style, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYouTube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000020362251492478657300000012278841539328618385_);fill:#FF0000;}\r\n\t.st1{clip-path:url(#SVGID_00000020362251492478657300000012278841539328618385_);fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 24,
    height: 24
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000179624944698645479170000002211537526140574615_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000179624944698645479170000002211537526140574615_)",
      fill: "#FF0000"
    },
    d: "M12,24 C5.37,24,0,18.63,0,12S5.37,0,12,0s12,5.37,12,12S18.63,24,12,24"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000179624944698645479170000002211537526140574615_)",
      fill: "#FFFFFF"
    },
    d: "M19.64,8.14 c-0.18-0.69-0.72-1.23-1.41-1.42C16.98,6.38,12,6.38,12,6.38s-4.99,0-6.23,0.34C5.09,6.9,4.55,7.45,4.37,8.14 C4.03,9.39,4.03,12,4.03,12s0,2.61,0.33,3.86c0.18,0.69,0.72,1.23,1.41,1.42C7.02,17.62,12,17.62,12,17.62s4.98,0,6.22-0.34 c0.69-0.18,1.23-0.73,1.41-1.42c0.33-1.25,0.33-3.86,0.33-3.86S19.97,9.39,19.64,8.14z M10.37,14.37V9.63L14.53,12L10.37,14.37z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTube);
export default __webpack_public_path__ + "static/media/youTube.340e7aaed563f5631ddc7ce2fc4bcb5c.svg";
export { ForwardRef as ReactComponent };